import { Box, Grid } from '@domain-group/suit-theme'

import type { CampaignModel, UserModel } from '@models/types'

import CampaignListItem from './CampaignListItem'
import CampaignTile from './CampaignTile'

interface ItemContainerProps {
  campaigns: CampaignModel[],
  currentUser: UserModel,
  displayMode: 'compact-list' | 'list' | 'tiles',
}

const ItemContainer = (props: ItemContainerProps) => {
  const {
    campaigns, currentUser, displayMode,
  } = props

  if (displayMode === 'compact-list' || displayMode === 'list'){
    return (
      <Box flexDirection="column" flexWrap="wrap">
        {campaigns.map(campaign => (
          <CampaignListItem
            campaign={campaign}
            currentUser={currentUser}
            displayMode={displayMode}
            key={campaign.id}
          />
        ))}
      </Box>
    )
  }

  return (
    <Grid
      // @ts-expect-error TS2322
      gridGap="medium"
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(auto-fill, minmax(240px, 1fr))"
      gridTemplateRows="repeat(auto-fill, minmax(240px, 1fr))"
      padding="large"
    >
      {campaigns.map(campaign => (
        <CampaignTile
          campaign={campaign}
          currentUser={currentUser}
          key={campaign.id}
        />
      ))}
    </Grid>
  )
}

export default ItemContainer
